import { z } from 'zod';
import { IsoDateCodec } from './date-codecs.js';

const DatabaseStatusSchema = z.literal('connected');

const SystemHealthOkResponseSchema = z.object({
  status: z.literal('ok'),
  database: DatabaseStatusSchema,
  userCount: z.number().int().nonnegative(),
  timestamp: IsoDateCodec,
});

const SystemHealthErrorResponseSchema = z.object({
  status: z.literal('error'),
  database: DatabaseStatusSchema,
  message: z.string(),
  timestamp: IsoDateCodec,
});

export const SystemHealthResponseSchema = z.discriminatedUnion('status', [
  SystemHealthOkResponseSchema,
  SystemHealthErrorResponseSchema,
]);

export type SystemHealthResponse = z.infer<typeof SystemHealthResponseSchema>;

export const SystemTestLoggingResponseSchema = z.object({
  success: z.literal(true),
  testId: z.string(),
  timestamp: IsoDateCodec,
  message: z.string(),
  environment: z.object({
    NODE_ENV: z.string().optional(),
    VERCEL_ENV: z.string().optional(),
    VERCEL: z.string().optional(),
    NEXT_RUNTIME: z.string(),
    hasBetterStackToken: z.boolean(),
    hasBetterStackUrl: z.boolean(),
    betterStackUrl: z.string().nullable(),
  }),
  dashboards: z.object({
    betterStack: z.string().url(),
  }),
});

export type SystemTestLoggingResponse = z.infer<typeof SystemTestLoggingResponseSchema>;
